import type { CollapseParams } from '@restore/dynamic-forms';
import { DocumentServiceCollapse } from './types';
import { convertBoolean } from './convertBoolean';

export const collapse = (
  collapseProperties: DocumentServiceCollapse | undefined,
  hidden?: 'Yes' | 'No'
): CollapseParams | undefined => {
  if (!collapseProperties) {
    return undefined;
  }

  const parsed: CollapseParams = {
    ...collapseProperties,
    text: collapseProperties.text,
    collapsed: convertBoolean(collapseProperties.status),
    hideHeading: convertBoolean(hidden),
  };

  return parsed;
};
